import { HeadFC, PageProps } from "gatsby";
import React, { Suspense } from "react";
import useAutoHideOrderTracking from "../layout/DefaultLayout/DefaultHeader/OrderTracking/useAutoHideOrderTracking";
import useAutoHideTopDeliveryStatus from "../store/reducers/CartSlice/hooks/useAutoHideTopDeliveryStatus";
import AccountLoyalty from "@src/components/page-content/Account/AccountLoyalty/AccountLoyalty";
import { PageContextIntl } from "@src/components/general/WrapPageElement/PageContext";
import DefaultHead from "@src/lib/Head/DefaultHead";
import { GATSBY_NO_COMEIN } from "@src/utils/constants";
const AccountProfile = React.lazy(
  () =>
    import("@src/components/page-content/Account/AccountProfile/AccountProfile")
);

const AccountPage = (props: PageProps<any, any>) => {
  useAutoHideOrderTracking();
  useAutoHideTopDeliveryStatus();
  return (
    <div>
      {GATSBY_NO_COMEIN ? (
        <Suspense>
          <AccountProfile />
        </Suspense>
      ) : (
        <AccountLoyalty />
      )}
    </div>
  );
};

AccountPage.Layout = "MyAccountLayout";

export const Head: HeadFC<any, PageContextIntl> = (headProps) => {
  return <DefaultHead {...headProps} />;
};

export default AccountPage;
